import { schema } from "normalizr";

const clusterSchema = new schema.Entity("clusters", {
    idAttribute: "cluster"
});

export default clusterSchema;



// WEBPACK FOOTER //
// ./src/schemas/cluster.js